(() => {
  function compactSpecs(root = document) {
    root.querySelectorAll('.product__description').forEach(desc => {
      const content = desc.querySelector('.wdlt-description-content') || desc;
      const blocks = Array.from(content.querySelectorAll('div,p')).filter(el => !el.querySelector('div,p'));
      const isSpec = el => /^((?:Vendor\s+)?(?:Color|Colour|Style(?:\s+Code)?)\s*:|Care\s*:|Lining\s*:|Fabrication\s*:|Composition\s*:|Materials?\s*:|Dimensions?\s*:|Measurements?\s*:|Chain\s+Length\s*:|Weight\s*:|Made\s+in\b|Imported\b|One\s+size\b)/i.test(el.textContent.trim());
      const isPolicy = el => /^(?:COLLABORATION\s+COLLECTION\s*[-–—]\s*)?Final\s+Sale\s*(?:\(\s*No\s+Returns\s+or\s+Exchanges\s*\)|[-–—]\s*no\s+returns\s+or\s+exchanges\.?)?\s*\*{0,2}\.?$/i.test(el.textContent.trim());
      content.querySelectorAll('p,div').forEach(el => {
        if (!el.textContent.trim() && !el.querySelector('img,picture,video,audio,iframe,svg,input,button,table')) el.classList.add('wdlt-empty-description');
      });

      const narrative = blocks.filter(el => el.matches('p,div') && el.textContent.trim() && !isSpec(el) && !isPolicy(el) && !el.closest('li,table') && !el.querySelector('br,img,video,iframe,ul,ol,table'));
      if (narrative.length === 1 && !content.querySelector('[data-wdlt-paragraph-split]') && typeof Intl.Segmenter === 'function') {
        const paragraph = narrative[0];
        const text = paragraph.textContent;
        if (text.trim().length >= 380 && text.trim().split(/\s+/).length >= 60) {
          const sentences = Array.from(new Intl.Segmenter('en', { granularity: 'sentence' }).segment(text));
          const candidates = sentences.slice(1).map(part => part.index).filter(index => index > text.length * .3 && index < text.length * .75);
          const boundary = candidates.sort((a,b) => Math.abs(a-text.length*.55)-Math.abs(b-text.length*.55))[0];
          if (boundary) {
            const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
            let node, offset = 0;
            while ((node = walker.nextNode())) {
              if (offset + node.length >= boundary) {
                const range = document.createRange();
                range.selectNodeContents(paragraph);
                range.setStart(node, boundary-offset);
                const second = paragraph.cloneNode(false);
                second.removeAttribute('id');
                second.dataset.wdltParagraphSplit = 'true';
                second.append(range.extractContents());
                paragraph.dataset.wdltParagraphSplit = 'true';
                paragraph.after(second);
                break;
              }
              offset += node.length;
            }
          }
        }
      }
      content.querySelectorAll('.wdlt-spec-heading').forEach(el => el.remove());
      let previousSpec = false;
      let headingAdded = false;
      blocks.forEach(el => {
        el.classList.remove('wdlt-spec-first', 'wdlt-spec-row', 'wdlt-spec');
        if (!el.textContent.trim()) return;
        if (isPolicy(el)) {
          el.classList.add('wdlt-duplicate-policy');
          return;
        }
        if (isSpec(el)) {
          if (!headingAdded) {
            const heading = document.createElement('h3');
            heading.className = 'wdlt-spec-heading';
            heading.textContent = 'Details:';
            el.before(heading);
            headingAdded = true;
          }
          el.classList.add('wdlt-spec-row', previousSpec ? 'wdlt-spec' : 'wdlt-spec-first');
          previousSpec = true;
        } else previousSpec = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => compactSpecs());
  else compactSpecs();
  document.addEventListener('shopify:section:load', event => compactSpecs(event.target));
})();
